
   const personal_care_images = [
      {
         key: 1,
         name: "Godrej No.1 Lime Aloe Vera Bathing Soap",
         priceint: 99,
         weight: "4x100 g",
         src: require("./Godrej Lime Aloe Vera Bathing Soap.webp"),
         price: "₹ 99 / 4x100 g"
       },
       {
         key: 2,
         name: "Dettol Intense Cool Bathing Soap bar with 2x Menthol",
         priceint: 119,
         weight: "3x75 g",
         src: require("./Dettol Intense Cool Bathing Soap bar with 2x Menthol.webp"),
         price: "₹ 119 / 3x75 g"
       },
       {
         key: 3,
         name: "BOROPLUS Antiseptic + Moisturising Soap - Neem, Tulsi & Aloe Vera",
         priceint: 158,
         weight: "6x125 g",
         src: require("./BOROPLUS Antiseptic + Moisturising Soap - Neem, Tulsi & Aloe Vera.webp"),
         price: "₹ 158 / 6x125 g"
       },
       {
         key: 4,
         name: "Godrej No.1 Sandal Turmeric Bathing Soap",
         priceint: 173,
         weight: "3x150 g",
         src: require("./Godrej No.1 Sandal Turmeric Bathing Soap.webp"),
         price: "₹ 173 / 3x150 g"
       },
       {
         key: 5,
         name: "CINTHOL Original Soap",
         priceint: 155,
         weight: "4x100 g",
         src: require("./CINTHOL Original Soap.webp"),
         price: "₹ 155 / 4x100 g"
       },
       {
         key: 6,
         name: "Dettol Liquid, Original Hand Wash Bottle",
         priceint: 109,
         weight: "900 ml",
         src: require("./Dettol Liquid, Original Hand Wash Bottle.webp"),
         price: "₹ 109 / 900 ml"
       },
       {
         key: 7,
         name: "DOVE Cream Beauty Bar - Soft, Smooth, Moisturised Skin",
         priceint: 260,
         weight: "3x125 g",
         src: require("./DOVE Cream Beauty Bar - Soft, Smooth, Moisturised Skin.webp"),
         price: "₹ 260 / 3x125 g"
       },
       {
         key: 8,
         name: "Dettol Original Germ Protection Bathing Soap bar",
         priceint: 159,
         weight: "4x75 g",
         src: require("./Dettol Original Germ Protection Bathing Soap bar.webp"),
         price: "₹ 159 / 4x75 g"
       },
       {
         key: 9,
         name: "Dettol Skincare Hand Wash Refill Pouch",
         priceint: 169,
         weight: "1500 ml",
         src: require("./Dettol Skincare Hand Wash Refill Pouch.webp"),
         price: "₹ 169 / 1500 ml"
       },
       {
         key: 10,
         name: "Dettol Original Liquid Hand Wash Refill Pouch",
         priceint: 169,
         weight: "1500 ml",
         src: require("./Dettol Original Liquid Hand Wash Refill Pouch.webp"),
         price: "₹ 169 / 1500 ml",
       },
       {
         key: 11,
         name: "Pears Pure & Gentle Bathing Bar",
         priceint: 436,
         weight: "8x125 g",
         src: require("./Pears Pure & Gentle Bathing Bar.webp"),
         price: "₹ 436 / 8x125 g"
       },
       {
         key: 12,
         name: "Dettol Germ Protection ph-Balanced Liquid Refill, Skincare Hand Wash Pouch",
         priceint: 89,
         weight: "675 ml",
         src: require("./Dettol Germ Protection ph-Balanced Liquid Refill, Skincare Hand Wash Pouch.webp"),
         price: "₹ 89 / 675 ml"
       },
       {
         key: 13,
         name: "LUX International Creamy Swiss Moisturizer Beauty Soap For Glowing Skin Mega Pack",
         priceint: 261,
         weight: "4x125 g",
         src: require("./LUX International Creamy Swiss Moisturizer Beauty Soap For Glowing Skin Mega Pack.webp"),
         price: "₹ 261 / 4x125 g"
       },
       {
         key: 14,
         name: "Dettol Original Germ Protection Soap bar",
         priceint: 269,
         weight: "4x125 g",
         src: require("./Dettol Original Germ Protection Soap bar.webp"),
         price: "₹ 269 / 4x125 g"
       },
       {
         key: 15,
         name: "BOROPLUS Antiseptic + Moisturising Soap - Neem, Eucalyptus & Honey",
         priceint: 175,
         weight: "6x125 g",
         src: require("./BOROPLUS Antiseptic + Moisturising Soap - Neem, Eucalyptus & Honey.webp"),
         price: "₹ 175 / 6x125 g"
       },
       {
         key: 16,
         name: "POND's Bright beauty Spot Less Glow Face Wash",
         priceint: 168,
         weight: "150 g",
         src: require("./POND's Bright beauty Spot Less Glow Face Wash.webp"),
         price: "₹ 168 / 150 g"
       },
       {
         key: 17,
         name: "Santoor by Wipro Sandal and Turmeric Soap for Younger Looking & Glowing Skin",
         priceint: 131,
         weight: "4x100 g",
         src: require("./Santoor by Wipro Sandal and Turmeric Soap for Younger Looking & Glowing Skin.webp"),
         price: "₹ 131 / 4x100 g"
       },
       {
         key: 18,
         name: "Pears Pure & Gentle, 98% Pure Glycerin and Natural Oils, Bathing Bar",
         priceint: 368,
         weight: "4x125 g",
         src: require("./Pears Pure & Gentle, Pure Glycerin and Natural Oils, Bathing Bar.webp"),
         price: "₹ 368 / 4x125 g"
       },
      {
        name: "BAJAJ 100% Pure Coconut Hair Oil",
        price: "₹ 140 / 600ml",
        priceint: 140,
        weight: "600 ml",
        src: require("./BAJAJ  Pure Coconut Hair Oil.webp")
      },
      {
        name: "Parachute Pure Coconut Hair Oil",
        price: "₹ 113 / 300ml",
        priceint: 113,
        weight: "300 ml",
        src: require("./Parachute Pure Coconut Hair Oil.webp")
      },
      {
        name: "BAJAJ Almond Drops Hair Oil enriched with 6X Vitamin E, Reduces Hair Fall, 650 ml Hair Oil",
        price: "₹ 352 / 650ml",
        priceint: 352,
        weight: "650 ml",
        src: require("./BAJAJ Almond Drops Hair Oil.webp")
      },
      {
        name: "Parachute Advansed Gold Coconut with Vitamin-E for Long, Strong & Gorgeous Hair Oil",
        price: "₹ 199 / 400ml",
        priceint: 199,
        weight: "400 ml",
        src: require("./Parachute Advansed Gold Coconut Hair Oil.webp")
      },
      {
        name: "EMAMI 7 Oils In One Hair Oil",
        price: "₹ 173 / 500ml",
        priceint: 173,
        weight: "500 ml",
        src: require("./EMAMI  Oils In One Hair Oil.webp")
      },
      {
        name: "CARA MIA 100% Pure Coconut Hair Oil",
        price: "₹ 112 / 500ml",
        priceint: 112,
        weight: "500 ml",
        src: require("./CARA MIA  Pure Coconut Hair Oil.webp")
      },
      {
        name: "Dabur Almond Shampoo for Dull, Dry and Weak Hair",
        price: "₹ 213 / 650ml",
        priceint: 213,
        weight: "650 ml",
        src: require("./Dabur Almond Shampoo.webp")
      },
      {
        name: "Godrej Expert Rich Creme Hair Colour Pack of 4 , Natural Black",
        price: "₹ 113 / 80ml",
        priceint: 113,
        weight: "80 ml",
        src: require("./Godrej Expert Rich Creme Hair Colour.webp")
      },
      {
        name: "Dettol Effective Protection Antiseptic Liquid",
        price: "₹327 / 1000 ml",
        priceint: 327,
        weight: "1000 ml",
        src: require("./Dettol Effective Protection Antiseptic Liquid.webp")
      },
      {
        name: "Dettol Effective Protection Antiseptic Liquid",
        price: "₹196 / 550 ml",
        priceint: 196,
        weight: "550 ml",
        src: require("./Dettol Effective Protection Antiseptic Liquid.webp")
      },
      {
        name: "MOOV Fast Pain Relief Spray",
        price: "₹205 / 50 g",
        priceint: 205,
        weight: "50 g",
        src: require("./MOOV Fast Pain Relief Spray.webp")
      },
      {
        name: "Dettol Disinfectant Lime Fresh Antiseptic Liquid",
        price: "₹251 / 1 L",
        priceint: 251,
        weight: "1 L",
        src: require("./Dettol Disinfectant Lime Fresh Antiseptic Liquid.webp")
      },
      {
        name: "Savlon Disinfectant Antiseptic Liquid",
        price: "₹264 / 1 L",
        priceint: 264,
        weight: "1 L",
        src: require("./Savlon Disinfectant Antiseptic Liquid.webp")
      },
      {
        name: "Flipkart SmartBuy Cotton Buds with Paper Stick",
        price: "₹32 / 100 Units",
        priceint: 32,
        weight: "100 Units",
        src: require("./Flipkart SmartBuy Cotton Buds with Paper Stick.webp")
      },
      {
        name: "Dettol Liquid Disinfectant for Floor Cleaner,Lavender Blossom,Surface Disinfection,Personal Hygiene Antiseptic Liquid",
        price: "₹326 / 1000 ml",
        priceint: 326,
        weight: "1000 ml",
        src: require("./Dettol Liquid Disinfectant for Floor Cleaner,Lavender.webp")
      },
      {
        name: "Dettol Disinfectant Menthol Cool Antiseptic Liquid",
        price: "₹199 / 500 ml",
        priceint: 199,
        weight: "500 ml",
        src: require("./Dettol Disinfectant Menthol Cool Antiseptic Liquid.webp")
      }
   ]
   
   export default personal_care_images;